import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

// Formatadores pt-BR — números com 2 casas e separador de milhar (RN-11/RN-12).
const fmtNum = (valor, casas = 2) => {
  if (valor === null || valor === undefined || isNaN(valor)) return '-';
  return Number(valor).toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
};

const fmtMesAno = (data) => {
  if (!data) return '-';
  const m = moment(data);
  return m.isValid() ? m.format('MM/YYYY') : '-';
};

const SubGrid = ({ titulo, children }) => (
  <div className="mb-3">
    <h6
      className="mb-1"
      style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0747a6' }}
    >
      {titulo}
    </h6>
    {children}
  </div>
);

const TabelaVazia = () => (
  <div
    className="text-muted small text-center py-2 border rounded"
    style={{ backgroundColor: '#f8f9fa' }}
  >
    Nenhum registro
  </div>
);

const SubSecoesEmpreendimento = ({ item }) => {
  if (!item) return null;

  const codigoFamilia = item.codigo_familia;
  const areas = item.areas || [];
  const contasProjeto = item.contas_projeto || [];
  const expectativaVendas = item.expectativa_vendas || [];
  const obrasCabecalho = item.obras_cabecalho || [];
  const obrasItens = item.obras_itens || [];

  return (
    <div className="px-3 py-2" style={{ backgroundColor: '#fafbfd' }}>
      {/* 1. Áreas */}
      <SubGrid titulo="Áreas">
        {areas.length === 0 ? (
          <TabelaVazia />
        ) : (
          <Table size="sm" striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Código</th>
                <th>Nome</th>
              </tr>
            </thead>
            <tbody>
              {areas.map((a) => (
                <tr key={`${codigoFamilia}-area-${a.codigo_ativo}`}>
                  <td>{a.codigo_ativo}</td>
                  <td>{a.nome}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </SubGrid>

      {/* 2. Contas Projetos */}
      <SubGrid titulo="Contas Projetos">
        {contasProjeto.length === 0 ? (
          <TabelaVazia />
        ) : (
          <Table size="sm" striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th style={{ width: '60px' }}>GE</th>
                <th style={{ width: '90px' }}>Conta</th>
                <th>Apelido</th>
                <th style={{ textAlign: 'right', width: '90px' }}>%</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {contasProjeto.map((c) => (
                <tr
                  key={`${codigoFamilia}-cp-${c.codigo_grupo_empresa}-${c.codigo_conta}`}
                >
                  <td>{c.codigo_grupo_empresa}</td>
                  <td>{c.codigo_conta}</td>
                  <td>{c.apelido_conta}</td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(c.percentual)}
                  </td>
                  <td>{c.tipo_descricao || '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </SubGrid>

      {/* 3. Expectativa de Vendas */}
      <SubGrid titulo="Expectativa de Vendas">
        {expectativaVendas.length === 0 ? (
          <TabelaVazia />
        ) : (
          <Table size="sm" striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th style={{ width: '110px' }}>Mês/Ano</th>
                <th style={{ textAlign: 'right', width: '100px' }}>% Mês</th>
                <th style={{ textAlign: 'right', width: '110px' }}>
                  % Acumulado
                </th>
                <th style={{ textAlign: 'right' }}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {expectativaVendas.map((e, idx) => (
                <tr
                  key={`${codigoFamilia}-ev-${moment(e.data).isValid() ? moment(e.data).format('YYYYMM') : idx}`}
                >
                  <td>{fmtMesAno(e.data)}</td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(e.percentual_mes)}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(e.percentual_acum)}
                  </td>
                  <td style={{ textAlign: 'right' }}>{fmtNum(e.valor)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </SubGrid>

      {/* 4. Obras — Cabeçalho */}
      <SubGrid titulo="Obras — Cabeçalho">
        {obrasCabecalho.length === 0 ? (
          <TabelaVazia />
        ) : (
          <Table size="sm" striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th style={{ width: '60px' }}>GE</th>
                <th style={{ width: '90px' }}>Conta</th>
                <th>Apelido</th>
                <th style={{ textAlign: 'right' }}>Valor Orçado</th>
              </tr>
            </thead>
            <tbody>
              {obrasCabecalho.map((o) => (
                <tr
                  key={`${codigoFamilia}-oc-${o.codigo_grupo_empresa}-${o.codigo_conta}`}
                >
                  <td>{o.codigo_grupo_empresa}</td>
                  <td>{o.codigo_conta}</td>
                  <td>{o.apelido_conta}</td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(o.valor_orcado)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </SubGrid>

      {/* 5. Obras — Itens */}
      <SubGrid titulo="Obras — Itens">
        {obrasItens.length === 0 ? (
          <TabelaVazia />
        ) : (
          <Table size="sm" striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th style={{ width: '90px' }}>Conta</th>
                <th style={{ width: '110px' }}>Mês/Ano</th>
                <th style={{ textAlign: 'right', width: '90px' }}>% Mês</th>
                <th style={{ textAlign: 'right' }}>Valor Mês</th>
                <th style={{ textAlign: 'right', width: '110px' }}>
                  % Acum.
                </th>
                <th style={{ textAlign: 'right' }}>Valor Acum.</th>
              </tr>
            </thead>
            <tbody>
              {obrasItens.map((o, idx) => (
                <tr
                  key={`${codigoFamilia}-oi-${o.codigo_conta}-${moment(o.data).isValid() ? moment(o.data).format('YYYYMM') : idx}`}
                >
                  <td>{o.codigo_conta}</td>
                  <td>{fmtMesAno(o.data)}</td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(o.percentual_mes)}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(o.valor_mes)}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(o.percentual_acum)}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {fmtNum(o.valor_acum)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </SubGrid>
    </div>
  );
};

export default SubSecoesEmpreendimento;
